import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import classes from './DayFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import CustomCalendarPicker from '../../../../CustomWeekPicker/CustomCalendarPicker';
import { calendarTypes, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import { useWindowSize } from '../../../../../../utils/hooks';
import MainButton from '../../../../buttons/MainButton';
import { buttonVariants } from '../../../../buttons/types';
import { generalEnums } from '../../../../../../utils/enums';
import colors from '../../../../../../scss/colors';

export default function DayFilter({
  daysAvailability = [],
  day = '',
  changeDay,
  dateBackAction,
  dateForwardAction,
  loading
}) {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState('');
  const { t } = useTranslation();
  const size = useWindowSize();

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction(date || '');
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.day')}
      text={t('dashboard.timesheets.filters.day')}
      active={!!day}
      open={open}
      setOpen={handleFilterToggle}
      sxBox={{
        padding: '36px 0 22px 0'
      }}
      extraHeader={{
        enabled: !!day,
        label: t('common.filters.reset'),
        action: () => {
          changeDay('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        <CustomCalendarPicker
          dateDisablingAbility
          daysAvailability={daysAvailability}
          userDate={day ? dayjs(day) : null}
          setUserDate={(pickedDay) => {
            changeDay(dayjs(pickedDay.toString()).format('DD-MMM-YYYY'));
            setDate(dayjs(pickedDay).format(generalEnums.DATEFORMAT));
            if (size.width > responsiveSizeTimesheet) setOpen(false);
            setOpen(false);
          }}
          calendarType={calendarTypes.DAY}
          dateBackAction={dateBackAction}
          dateForwardAction={dateForwardAction}
          loading={loading}
        />
        {day && size.width > responsiveSizeTimesheet && (
          <MainButton
            variant={buttonVariants.SECONDARY}
            outlined
            rounded
            size={size.width < responsiveSizeTimesheet ? 'small' : 'xsmall'}
            forceWidth={size.width < responsiveSizeTimesheet ? '100%' : '136px'}
            action={() => {
              changeDay('');
              setOpen(false);
            }}
            sx={{
              color: colors.MEDIUM_GREY,
              borderColor: colors.MEDIUM_GREY
            }}
          >
            <p>{t('dashboard.timesheets.filters.reset')}</p>
          </MainButton>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
